import React from 'react';

import {
  RouteHighwayRegularIcon,
  ScribbleRegularIcon,
  TrafficLightRegularIcon,
  TruckRampCouchRegularIcon
} from '../../shared/icons/icons';

interface TreadwellPersonaIconProps {
  className?: String;
  iconName?: String | null;
}

function TreadwellPersonaIcon(props: TreadwellPersonaIconProps) {
  const { className, iconName } = props;

  let Icon;
  switch (iconName) {
    case 'RouteHighwayRegularIcon':
      Icon = RouteHighwayRegularIcon;
      break;
    case 'ScribbleRegularIcon':
      Icon = ScribbleRegularIcon;
      break;
    case 'TruckRampCouchRegularIcon':
      Icon = TruckRampCouchRegularIcon;
      break;
    case 'TrafficLightRegularIcon':
      Icon = TrafficLightRegularIcon;
      break;
    default:
      Icon = TrafficLightRegularIcon;
      break;
  }

  return <Icon className={className} />;
}

export default TreadwellPersonaIcon;
